module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley"
  }, [_c('div', {
    staticClass: "body Chapter"
  }, [_c('p', {
    attrs: {
      "id": "rw-p_137514-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_17"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_17"
    }
  }), _c('div', {
    staticClass: "title-block",
    attrs: {
      "id": "rw-title-block_137514-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_17"
    }
  }), _c('h1', [_c('a', {
    attrs: {
      "id": "pb-rw_17"
    }
  }), _c('a', {
    attrs: {
      "href": "#/9781847675026_tableofcontents"
    }
  }, [_vm._v("THE COMEDY OF THE WHITE DOG")])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_137514-00002"
    }
  }, [_vm._v("On a sunny afternoon two men went by car into the suburbs to the house of a girl called Nan. Neither was much older than twenty years. One of them, Kenneth, was self-confident and well dressed and his friends thought him very witty. He owned and drove the car. The other, Gordon, was more quiet. His clothes were as good as Kenneth’s but he inhabited them less easily. He had never been to this girl’s house before and felt nervous. An expensive bunch of flowers lay on his lap.")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_137514-00001"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_137514-00001"
    }
  }, [_vm._v("Kenneth stopped the car before a broad-fronted bungalow with a badly kept lawn. The two men had walked halfway up the path to the door when Kenneth stopped and pointed to a dog which lay basking in the grass. It was a small white sturdy dog with a blunt pinkish muzzle and a stumpy tail. It lay with legs stuck out at right angles to its body, its eyes were shut tight and mouth open in a grin through which the tongue lolled. Kenneth and Gordon laughed and Gordon said, “What’s so funny about him?”")]), _vm._v(" "), _c('div', {
    staticClass: "media image align-center width-auto",
    attrs: {
      "id": "rw-media-image_137514-00001"
    }
  }, [_c('div', {
    staticClass: "pc"
  }, [_c('img', {
    attrs: {
      "alt": "alt",
      "src": "17-1.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_137514-00003"
    }
  }, [_vm._v("Kenneth said, “He looks "), _c('a', {
    attrs: {
      "id": "pb-rw_18"
    }
  }, [_vm._v("like a toy dog knocked over on its side.”\n         ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_18"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_137514-00004"
    }
  }, [_vm._v("“Is he asleep?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00005"
    }
  }, [_vm._v("“Don’t fool yourself. He hears every word we say.”")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_137514-00002"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_137514-00002"
    }
  }, [_vm._v("The dog opened its eyes, sneezed and got up. It came over to Gordon and grinned up at him but evaded his hand when he bent down to pat it and trotted up the path and touched the front door with its nose. The door opened and the dog disappeared into a dark hall. Kenneth and Gordon stood on the front step stamping their feet on the mat and clearing their throats. Sounds of female voices and clattering plates came from nearby and the noise of a wireless from elsewhere. Kenneth shouted, “Ahoi!” and Nan came out of a side door. She was a pleasant-faced blonde who would have seemed plump if her waist, wrists and ankles had not been slender. She wore an apron over a blue frock and held a moist plate in one hand. Kenneth said jocularly, “The dog opened the door to us.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00006"
    }
  }, [_vm._v("“Did he? That was wicked of him. Hullo, Gordon, why, what nice flowers. You’re always kind to me. Leave them on the hallstand and I’ll put them in water.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00007"
    }
  }, [_vm._v("“What sort of dog is he?” said Gordon.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00008"
    }
  }, [_vm._v("“I’m not sure, but when we were on holiday up at Ardnamurchan the local inhabitants mistook him for a pig.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00009"
    }
  }, [_vm._v("A woman’s voice shouted, “Nan! The cake!”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00010"
    }
  }, [_vm._v("“Oh, I’ll have to rush now, I’ve a cake to ice. Take Gordon into the living room, Kenneth; the others haven’t arrived yet so you’ll have to entertain each other. Pour yourselves a drink if you like.”")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_137514-00003"
    }
  })]), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_137514-00003"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_18"
    }
  }, [_vm._v("The living room was at the back of the house. The curtains, wallpaper and carpets had bright patterns that didn’t harmonize. There was an ")]), _c('a', {
    attrs: {
      "id": "pb-rw_19"
    }
  }, [_vm._v("assortment of chairs and the white dog lay on the most comfortable. There was a big very solid oval table, and a grand piano with two bottles of cider and several tumblers on it. “I see we’re not going to have an orgy anyway,” said Gordon, pouring cider into a tumbler.\n         ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_19"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_137514-00011"
    }
  }, [_vm._v("“No, no. It’s going to be a nice little family party,” said Kenneth, seating himself at the piano and starting to play. He played badly but with confidence, attempting the best known bits of works by Beethoven and Schumann. If he particularly enjoyed a phrase he repeated it until it bored him; if he made a passage illegible with too many discords he repeated it until it improved. Gordon stood with the tumbler in his hand, looking out the window. It opened on a long narrow lawn which sloped down between hedges to a shrubbery.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00012"
    }
  }, [_vm._v("“Are you in love with Nan?” said Kenneth, still playing.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00013"
    }
  }, [_vm._v("“Yes. Mind you, I don’t know her well,” said Gordon.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00014"
    }
  }, [_vm._v("“Hm. She’s too matronly for me.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00015"
    }
  }, [_vm._v("“I don’t think she’s matronly.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00016"
    }
  }, [_vm._v("“What do you like about her?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00017"
    }
  }, [_vm._v("“Most things. I like her calmness. She’s got a very calm sort of beauty.”")])]), _c('p', {
    attrs: {
      "id": "rw-p_137514-00018"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_19"
    }
  }, [_vm._v("Kenneth stopped playing and sat looking thoughtful. Voices and clattering dishes could be heard from the kitchen, a telephone was ringing and the noise of a wireless still came loudly from somewhere. Kenneth said, “She’s not calm when she’s at home. They’re all very nice folk, pleasant and sincere I mean, but you’ll find all the women of this family – Nan, her mother and grandmother and aunt – all talk too loudly at the same time. It’s never quiet in this house. Either the wireless is on loudly, or the ")]), _c('a', {
    attrs: {
      "id": "pb-rw_20"
    }
  }, [_vm._v("gramophone, or both. I’ve been to one or two parties here. There are never many guests but I’ve always felt there are other parties going on in rooms of the house I don’t know about. Do you want to marry Nan?”\n         ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_20"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_137514-00019"
    }
  }, [_vm._v("“Of course. I told you I loved her.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00020"
    }
  }, [_vm._v("Kenneth laughed and swung from side to side on the piano stool, making it squeak. He said, “Don’t mistake me – there’s nothing disorderly about the house. Nobody drinks anything stronger than cider. Nan’s father and brothers are so quiet as to be socially non-existent. You only see them at mealtimes and not always then. In fact I’m not sure how many brothers she has, or how large this family is. What are you grinning at?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00021"
    }
  }, [_vm._v("“I wish I could talk like you,” said Gordon. “You’ve told me nothing surprising about Nan’s family, yet you’ve made it seem downright sinister.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00022"
    }
  }, [_vm._v("Kenneth began to fumble out the tune of ‘The Lark in the Clear Air’.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00023"
    }
  }, [_vm._v("“Anyway,” he said, “you won’t get a chance to be alone with her, which is what you most want, I suppose.”")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_137514-00004"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_137514-00004"
    }
  }, [_vm._v("Nan came in and said, “Gibson and Clare will be here in half an hour … er … would you like to have tea in the garden? It’s a good day for it. Mum doesn’t like the idea much.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00024"
    }
  }, [_vm._v("“I think it’s a fine idea,” said Kenneth.")])]), _c('p', {
    attrs: {
      "id": "rw-p_137514-00025"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_20"
    }
  }, [_vm._v("“Oh, good. Perhaps you’ll help us with the table?” Gordon and Kenneth took the legs off the table, carried the pieces on to the back lawn and reassembled it, then put chairs round it and helped to set it. While they did so Nan’s mother, a small gay woman, kept running out and shouting useless directions: “Put that cake in the middle, Gordon! No, nearer the top! Did ye need to plant the table so ")]), _c('a', {
    attrs: {
      "id": "pb-rw_21"
    }
  }, [_vm._v("far from the house? You’ve given yourself a lot of useless work. Well, well, it’s a nice day. Where’s my dog? Where’s my dog? Aha, there he is below the table! Come out, ye bizum! No, don’t tease him, Kenneth! You’ll only drive him mad.”\n         ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_21"
    }
  }, [_c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_137514-00005"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_137514-00005"
    }
  }, [_vm._v("Gibson and Clare arrived. Gibson was a short thickly built man whose chin always looked swarthy. At first sight he gave a wrong impression of strength and silence, for he was asthmatic and this made his movements slow and deliberate. Though not older than Gordon or Kenneth his hair was getting thin. As soon as he felt at ease in a company he would talk expertly about books, art, politics and anything that was not direct experience. Clare, his girl-friend, was nearly six feet tall and beautiful in a consciously chaste way. Her voice was high-pitched, pure and clear, and she listened to conversation with large wide-open eyes and lustrous lips slightly parted. Her favourite joke was to suspect an indecency in an ordinary remark and to publicize it with a little exclamation and giggle. Kenneth had nicknamed the two Intellect and Spirit. He said there seemed nothing animal between them.")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_137514-00006"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_137514-00006"
    }
  }, [_vm._v("The tea was a pleasant one. Only Nan, her four guests and the dog were present, though. Nan’s mother often ran out with a fresh pot of tea or plate of food. The sun was bright, a slight breeze kept the air from being too warm, and Kenneth amused the company by talking about the dog.")])]), _c('p', {
    attrs: {
      "id": "rw-p_137514-00026"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_21"
    }
  }, [_vm._v("“There’s something heraldic about him,” he said. “It’s easy to imagine him with another head where his tail is. Look, he’s getting excitable! He wants to sit on a chair! Oh, I hope he doesn’t choose mine.” The dog had been trotting round the table in a wide circle, now it came toward Kenneth, wagging its tail ")]), _c('a', {
    attrs: {
      "id": "pb-rw_22"
    }
  }, [_vm._v("and grinning. Kenneth grabbed a plate of meringues and got down under the table with them. “These at least he shall not have!” he cried in a muffled trembling voice. The others laughed, left their chairs and finished the meal sitting on the grass. All but Gordon felt that pleasant drunkenness which comes from being happy in company. Kenneth crawled about the lawn on his knees with a sugar bowl in his hand and when he came to a daisy peered at it benevolently and dropped a small heap of sugar into the flower. Gibson crawled after him, adding drops from the milk jug. Clare sat with the dog on her lap and pretended to cut it up with a knife and fork. Actually she stroked and tickled its stomach gently with the edge of the knife and murmured baby-talk: ”Will I be cruel and eat oo up doggie? No, no, no, doggie, oo is too sweet a doggie to eat up.”\n         ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_22"
    }
  }, [_c('div', {
    staticClass: "media image align-center width-auto",
    attrs: {
      "id": "rw-media-image_137514-00002"
    }
  }, [_c('div', {
    staticClass: "pc"
  }, [_c('img', {
    attrs: {
      "alt": "alt",
      "src": "22-1.png"
    }
  })])])]), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_137514-00027"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_22"
    }
  }, [_vm._v("Nan had taken needles and wool from her apron pocket and was quietly knitting and smiling to herself. Gordon lay nearby pretending to sunbathe. He was worried. He really did not know Nan well. He had only seen her at the homes of friends, and had not even spoken to her much. His invitation to the party had been a surprise. Nan did not know him as well as several other people she might have invited. He had assumed she knew what he felt for her and was giving ")]), _c('a', {
    attrs: {
      "id": "pb-rw_23"
    }
  }, [_vm._v("him a chance to know her better, yet since he arrived she had not paid him any special attention. Now she sat placidly knitting, sometimes glancing sideways at Clare with a slight ironic smile; yet he believed he saw in her manner a secretive awareness of him, lying apart and wanting her.\n         ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_23"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_137514-00028"
    }
  }, [_vm._v("“Ach, the bitch,” he thought, “she’s sure of me. She thinks she can hurt me all she likes. Well, she’s wrong.” He got up, went to the table and started piling the plates together.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00029"
    }
  }, [_vm._v("“I’ll take these indoors,” he said.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00030"
    }
  }, [_vm._v("“Oh, don’t bother,” said Nan, smiling at him lazily. “Someone will have to shift them,” said Gordon sternly.")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_137514-00007"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_137514-00007"
    }
  }, [_vm._v("He took several journeys to carry the table things into the kitchen. It was cool and dim indoors. Nan’s father and three of her silent brothers were eating a meal at the kitchen table. They nodded to him. The mother was nowhere to be seen but he heard her voice among several shrill female voices in some other room. Gordon brought in the last table things and put them on the drying board of the sink, then stood awkwardly watching the four eaters. They were large men with stolid, clumsily moulded faces. Some lines on the father’s face were deeply cut, otherwise he looked very like his sons. He said to Gordon, “A warm evening.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00031"
    }
  }, [_vm._v("“Yes, I prefer it indoors.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00032"
    }
  }, [_vm._v("“Would you like a look at the library?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00033"
    }
  }, [_vm._v("“Er, yes, thanks, yes I would.”")])]), _c('p', {
    attrs: {
      "id": "rw-p_137514-00034"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_23"
    }
  }, [_vm._v("The father got up and led Gordon across the hall and down a short passage, opened a door and stood by to let Gordon through. The library had old glass-fronted bookcases on each wall. Between the bookcases hung framed autographed photographs ")]), _c('a', {
    attrs: {
      "id": "pb-rw_24"
    }
  }, [_vm._v("of D. Η. Lawrence, Havelock Ellis, Η. G. Wells and Bernard Shaw. There was a leather-covered armchair, and a round tin labelled ‘Edinburgh Rock’ on a low table beside it.\n         ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_24"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_137514-00035"
    }
  }, [_vm._v("“You’ve a lot of books,” said Gordon.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00036"
    }
  }, [_vm._v("“The wife’s people were great readers,” said Nan’s father. “Can I leave you now?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00037"
    }
  }, [_vm._v("“Oh yes. Oh yes.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00038"
    }
  }, [_vm._v("The father left. Gordon took a book at random from a shelf, sat down and turned the pages casually. It was a history of marine engineering. The library was on the opposite side of the hall from the living room, but its window also looked on to the back garden and sometimes Gordon heard an occasional shout or laugh or bark from those on the lawn. He told himself grimly, “I’m giving her a chance. If she wants me she can come to me here. In fact if she has ordinary politeness and decency she’ll be bound to look for me soon.” He imagined the things she might say and the things he would say back. Sometimes he consoled himself with a piece of rock from the tin.")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_137514-00008"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_137514-00008"
    }
  }, [_vm._v("Suddenly the door sprang open with a click and he saw coming through it towards him, not Nan, but the dog. It stopped in front of him and grinned up into his face. “What do you want?” said Gordon irritably. The dog wagged its tail. Gordon threw a bit of rock which it caught neatly in its jaws, then trotted out through the door. Gordon got up, slammed the door and sat down. A little later the door opened and the dog entered again.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00039"
    }
  }, [_vm._v("“Ye brute!” said Gordon. “Right, here’s your sweet; the last you’ll get from me.”")])]), _c('p', {
    attrs: {
      "id": "rw-p_137514-00040"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_24"
    }
  }, [_vm._v("He escorted the dog to the door, closed it carefully, ")]), _c('a', {
    attrs: {
      "id": "pb-rw_25"
    }
  }, [_vm._v("turned a key in the lock, then went back to the chair and book. After a while it struck him that with the door locked Nan wouldn’t get in if she came to him. He glanced uneasily up. The door was open and the dog stood before him, grinning with what seemed, to his stupified eyes, triumphant amusement. For a moment Gordon was too surprised to move. He noticed that the animal was grinning with its mouth "), _c('i', [_vm._v("shut")]), _vm._v(", a thing he had never seen a dog do before. He raised the book as if to throw it.\n         ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_25"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_137514-00041"
    }
  }, [_vm._v("“Grrr, get out!” he yelled. The dog turned jauntily and trotted away. After thinking carefully Gordon decided some joker must have unlocked the door from outside: it was the sort of pointless joke Kenneth liked. He listened carefully and heard from the lawn the voice of Kenneth and the barking of the dog. He decided to leave the door open.")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_137514-00009"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_137514-00009"
    }
  }, [_vm._v("Later he found it too dark to see the page of the book clearly and put it down. The noises from the lawn had subtly altered. The laughter and shouting were now not continuous. There were periods of silence disturbed by the occasional shuffle of running feet and the hard breathing of somebody pursued, then he would hear a half-cry or scream that did not sound altogether in fun. Gordon went to the window. Something strange was happening on the darkened lawn. Nan was nowhere to be seen. Kenneth, Gibson and Clare were huddled together on the bare table-top, Clare kneeling, Kenneth and Gibson crouching half-erect. The white dog danced in a circle round the table among over-turned chairs. Its activity and size seemed to have increased with the darkness. It glimmered like a sheet in the dusk, its white needle-teeth glittered in the silently laughing jaws, it was about the size of a small lion. Gibson was occupied in a strange way, searching his pockets for objects and hurling them at the shrubbery at the far end of the garden. The white dog would run, leap, catch these in its mouth while they were in the air, then return and deposit them under the table. It looked like a game and had possibly begun as one, but obviously Gibson was continuing in an effort to get the dog as far away as possible. Gordon suddenly discovered Nan was beside him, watching, her hands clenched against her mouth.")])]), _c('p', {
    attrs: {
      "id": "rw-p_137514-00042"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_25"
    }
  }), _c('a', {
    attrs: {
      "id": "pb-rw_26"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_26"
    }
  }, [_c('div', {
    staticClass: "media image align-center width-auto",
    attrs: {
      "id": "rw-media-image_137514-00003"
    }
  }, [_c('div', {
    staticClass: "pc"
  }, [_c('img', {
    attrs: {
      "alt": "alt",
      "src": "26-1.png"
    }
  })])])]), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_137514-00010"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_26"
    }
  }), _c('a', {
    attrs: {
      "id": "pb-rw_27"
    }
  }, [_vm._v("Gibson seemed to run out of things to throw. Gordon saw him expostulate precariously for a moment with Kenneth, demanding (it appeared) his fountain pen. Kenneth kept shaking his head. He was plainly not as frightened as Gibson or Clare, but a faint embarrassed smile on his face suggested that he was abashed by some monstrous possibility. Gibson put a hand to his mouth, withdrew something, then seemed to reason with Kenneth, who at last shrugged and took it with a distaste which suggested it was a plate of false teeth. Kenneth stood upright and, balancing himself with difficulty, hurled the object at the shrubbery. It was a good throw. The white dog catapulted after it and at once the three jumped from the table and ran to the house, Kenneth going to the right, Gibson and Clare to the left. The dog swerved in an abrupt arc and hurled toward the left. He overtook Clare and snapped the hem of her dress. She stumbled and fell. Gibson and Kenneth disappeared from sight and two doors were slammed in different parts of the house. Clare lay on the lawn, her knees drawn up almost to her chin, her clasped hands pressed between her thighs and her eyes shut. The dog ")]), _c('a', {
    attrs: {
      "id": "pb-rw_28"
    }
  }, [_vm._v("stood over her, grinning happily, then gathered some of the clothing round her waist into its mouth and trotted with her into the bushes of the shrubbery.\n         ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_28"
    }
  }, [_c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_137514-00010"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_137514-00011"
    }
  }, [_vm._v("Gordon looked at Nan. She had bowed her face into her hands. He put an arm round her waist, she laid her face against his chest and said in a muffled voice, “Take me away with you.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00044"
    }
  }, [_vm._v("“Are you sure of what you’re saying?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00045"
    }
  }, [_vm._v("“Take me away, Gordon.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00046"
    }
  }, [_vm._v("“What about Clare?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00047"
    }
  }, [_vm._v("Nan laughed vindictively. “Clare isn’t the one to pity.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00048"
    }
  }, [_vm._v("“Yes, but that dog!”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00049"
    }
  }, [_vm._v("Nan cried out, “"), _c('i', [_vm._v("Do you want me or not?")]), _vm._v("”\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_137514-00011"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_137514-00012"
    }
  }, [_vm._v("As they went through the dark hall, the kitchen door opened, Nan’s mother looked out, then shut it quickly. In the front garden they met Kenneth and Gibson, both shamefaced and subdued. Kenneth said, “Hullo. We were just coming to look for you.” Gordon said, “Nan’s coming home with me.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00050"
    }
  }, [_vm._v("Kenneth said, “Oh, good.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00051"
    }
  }, [_vm._v("They stood for a moment in silence, none of the men looking at each other, then Gibson said, “I suppose I’d better wait for Clare.” The absence of teeth made him sound senile. Nan cried out, “She won’t want "), _c('i', [_vm._v("you")]), _vm._v(" now! She won’t want "), _c('i', [_vm._v("you")]), _vm._v(" now!” and started weeping again.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00052"
    }
  }, [_vm._v("“I’ll wait all the same,” Gibson muttered. He turned his back on them. “How long do you think she’ll be?” he asked. Nobody answered.")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_137514-00012"
    }
  })]), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_137514-00013"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_28"
    }
  }, [_vm._v("The drive back into the city was quiet. Gordon sat with Nan in the back seat, his arm around her waist, her mourning face against his shoulder. He felt strangely careless and happy. Once Kenneth said, ")]), _c('a', {
    attrs: {
      "id": "pb-rw_29"
    }
  }, [_vm._v("“An odd sort of evening.” He seemed half willing to discuss it but nobody encouraged him. He put off Gordon and Nan at the close-mouth of the tenement where Gordon lived. They went upstairs to the top landing, Gordon unlocked a door and they crossed a small lobby into a very untidy room. Gordon said, “I’ll sleep on the sofa here. The bedroom’s through that door.”\n         ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_29"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_137514-00053"
    }
  }, [_vm._v("Nan sat on the sofa, smiled sadly and said, “So I’m not to sleep with you.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00054"
    }
  }, [_vm._v("“Not yet. I want you too much to take advantage of a passing mood.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00055"
    }
  }, [_vm._v("“You think this is a passing mood.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00056"
    }
  }, [_vm._v("“It might be. If it’s not I’ll see about getting a marriage licence. Are you over eighteen?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00057"
    }
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00058"
    }
  }, [_vm._v("“That’s good. Er … do you mind me wanting to marry you, Nan?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00059"
    }
  }, [_vm._v("Nan got up, embraced him and put her tear-dirty cheek against his. She laughed and said, “You’re very conventional.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00060"
    }
  }, [_vm._v("“There’s no substitute for legality,” said Gordon, rubbing his brow against hers.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00061"
    }
  }, [_vm._v("“There’s no substitute for impulse,” Nan whispered. “We’ll try and combine the two,” said Gordon. The pressure of her body started to excite him, so he stood apart from her and started making a bed on the sofa.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00062"
    }
  }, [_vm._v("“If you’re willing, tomorrow I’ll get a licence.” He had just settled comfortably on the sofa when Nan came to the bedroom door and said, “Gordon, promise you won’t ask me about him.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00063"
    }
  }, [_vm._v("“About who?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00064"
    }
  }, [_vm._v("“You can’t have forgotten him.”")])]), _c('p', {
    attrs: {
      "id": "rw-p_137514-00065"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_29"
    }
  }, [_vm._v("“The dog? Yes, I had forgotten the dog. All right, I won’t ask … You’re sure nothing serious has ")]), _c('a', {
    attrs: {
      "id": "pb-rw_30"
    }
  }, [_vm._v("happened to Clare?”\n         ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_30"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_137514-00066"
    }
  }, [_vm._v("“Ask her when you see her next!” Nan cried, and slammed the bedroom door.")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_137514-00013"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_137514-00014"
    }
  }, [_vm._v("Next day Gordon bought a marriage licence and an engagement ring and arranged the wedding for a fortnight later. The next two weeks were among the happiest in his life. During the day he worked as an engineering draughtsman. When he came home from work Nan had a good meal ready for him and the apartment clean and tidy. After the meal they would go walking or visit a film show or friends, and later on they would make rather clumsy love, for Gordon was inexperienced and got his most genuine pleasure by keeping the love-making inside definite limits. He wasn’t worried much by memories of the white dog. He prided himself on being thoroughly rational, and thought it irrational to feel curious about mysteries. He always refused to discuss things like dreams, ghosts, flying-saucers and religion. “It doesn’t matter if these things are true or not,” he said. “They are irrelevant to the rules that we have to live by. Mysteries only happen when people try to understand something irrelevant.” Somebody once pointed out to him that the creation of life was a mystery. “I know,” he said, “and it’s irrelevant. Why should I worry about how life occurred? If I know how it is just now I know enough.” This attitude allowed him to dismiss his memories of the white dog as irrelevant, especially when he learned that Clare seemed to have come to no harm. She had broken with Gibson and now went about a lot with Kenneth.")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_137514-00014"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_137514-00015"
    }
  }, [_vm._v("One day Nan said, “Isn’t tomorrow the day before the wedding?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00067"
    }
  }, [_vm._v("“Yes What about it?”")])]), _c('p', {
    attrs: {
      "id": "rw-p_137514-00069"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_30"
    }
  }), _c('a', {
    attrs: {
      "id": "pb-rw_31"
    }
  }, [_vm._v("“A man and woman aren’t supposed to see each other the night before their wedding.”")])]), _c('a', {
    attrs: {
      "id": "pb-rw_31"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_137514-00070"
    }
  }, [_vm._v("“I didn’t know that.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00071"
    }
  }, [_vm._v("“And I thought you were conventional.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00072"
    }
  }, [_vm._v("“I know what’s legal. I don’t much care about conventions.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00073"
    }
  }, [_vm._v("“Well, women care more about conventions than they do about laws.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00074"
    }
  }, [_vm._v("“Does that mean you want me to spend tomorrow night in a hotel?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00075"
    }
  }, [_vm._v("“It’s the proper thing, Gordon.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00076"
    }
  }, [_vm._v("“You weren’t so proper on the night I brought you here.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00077"
    }
  }, [_vm._v("Nan said quietly, “It’s not fair to remind me of that night.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00078"
    }
  }, [_vm._v("“I’m sorry,” said Gordon. “No, it’s not fair. I’ll go to a hotel.”")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_137514-00015"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_137514-00016"
    }
  }, [_vm._v("Next evening he booked a room in a hotel and then, since it was only ten o’clock, went to a coffee bar where he might see some friends. Inside Clare and Kenneth sat at a table with a lean young man Gordon did not know. Clare smiled and beckoned. She had lost her former self-conscious grace and looked adult and attractive. As Gordon approached Kenneth stood, gripped Gordon’s hand and shook it with unnecessary enthusiasm saying, “Gordon! Gordon! You must meet Mr. McIver. (Clare and I are just leaving.) Mr. McIver, this is the man I told you about, the only man in Scotland who can help you. Goodnight! Goodnight! Clare and I mustn’t intrude on your conversation. You have a lot to discuss.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00079"
    }
  }, [_vm._v("He rushed out, pulling Clare after him and chuckling.")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_137514-00016"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_137514-00017"
    }
  }, [_vm._v("Gordon and the stranger looked at each other with embarrassment.")])]), _c('p', {
    attrs: {
      "id": "rw-p_137514-00081"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_31"
    }
  }), _c('a', {
    attrs: {
      "id": "pb-rw_32"
    }
  }, [_vm._v("“Won’t you sit down?” said Mr. McIver in a polite North American voice. Gordon sat down and said, “Are you from the States, Mr. McIver?”")])]), _c('a', {
    attrs: {
      "id": "pb-rw_32"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_137514-00082"
    }
  }, [_vm._v("“No, from Canada. I’m visiting Europe on a scholarship. I’m collecting material for my thesis upon the white dog. Your friend tells me you are an authority on the subject.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00083"
    }
  }, [_vm._v("Gordon said abruptly, “What has Kenneth told you about the dog?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00084"
    }
  }, [_vm._v("“Nothing. But he said you could tell me a great deal.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00085"
    }
  }, [_vm._v("“He was joking.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00086"
    }
  }, [_vm._v("“I’m sorry to hear that.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00087"
    }
  }, [_vm._v("Gordon stood up to go, sat down again, hesitated and said, “What is this white dog?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00088"
    }
  }, [_vm._v("McIver answered in the tone of someone starting a lecture: “Well known references to the white dog occur in Ovid’s ’Metamorphoses’, in Chaucer’s unfinished ‘Cook’s Tale’, in the picaresque novels of the Basque poet Jose Mompou, and in your Scottish Border Ballads. Nonetheless, the white dog is the most neglected of European archetypes, and for that reason perhaps, one of the most significant. I can only account for this neglect by assuming a subconscious resistance in the minds of previous students of folk-lore, a resistance springing from the fact that the white dog is the west-European equivalent of the Oedipus myth.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00089"
    }
  }, [_vm._v("“That’s all just words,” said Gordon. “What does the dog "), _c('i', [_vm._v("do?")]), _vm._v("”\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00090"
    }
  }, [_vm._v("“Well, he’s usually associated with sexually frigid women. Sometimes it is suggested they are frigid because they have been dedicated to the love of the dog from birth …”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00091"
    }
  }, [_vm._v("“Dedicated by who?”")])]), _c('p', {
    attrs: {
      "id": "rw-p_137514-00092"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_32"
    }
  }, [_vm._v("“In certain romance legends by the priest at the ")]), _c('a', {
    attrs: {
      "id": "pb-rw_33"
    }
  }, [_vm._v("baptismal font, with or without the consent of the girl’s parents. More often the frigidity is the result of the girl’s choice. A girl meets an old woman in a lonely place who gives her various gifts, withholding one on which the girl’s heart is set. The price of the gift is that she consents to marry the old woman’s son. If she accepts the gift (it is usually an object of no value) she becomes frigid until the white dog claims her. The old woman is the dog’s mother. In these versions of the legend the dog is regarded as a malignant spirit.”\n         ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_33"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_137514-00093"
    }
  }, [_vm._v("“How can he be other than malignant?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00094"
    }
  }, [_vm._v("“In Sicily the dog is thought of as a benefactor of frigid or sterile women. If the dog can be induced to sleep with such a woman and she submits to him she will become capable of normal fruitful intercourse with a man. There is always a condition attached to this. The dog must always be, to a certain extent, the husband of the woman. Even if she marries a human man, the dog can claim her whenever he wants.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00095"
    }
  }, [_vm._v("“Oh God,” said Gordon.")])]), _c('p', {
    attrs: {
      "id": "rw-p_137514-00096"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_33"
    }
  }, [_vm._v("“There’s nothing horrible about it,” said McIver. “In one of Jose Mompou’s novels the hero encounters a brigand chieftain whose wife is also married to the dog. The dog and the chieftain are friends, the dog accepts the status of pet in the household, sleeping by the fire, licking the plates clean et cetera, even though he is the ghostly husband of several girls in the district. By his patronage of the house in this ostensibly servile capacity, he brings the brigand luck. His presence is not at all resented, even though he sometimes sleeps with the brigand’s daughters. To have been loved by the dog makes a woman more attractive to normal men, you see, and the dog is never jealous. When one of his women ")]), _c('a', {
    attrs: {
      "id": "pb-rw_34"
    }
  }, [_vm._v("marries he only sleeps with her often enough to assert his claim on her.”\n         ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_34"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_137514-00097"
    }
  }, [_vm._v("“How often is that?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00098"
    }
  }, [_vm._v("“Once a year. He sleeps with her on the night before the wedding and on each anniversary of that night. Say, how are you feeling? You look terrible.”")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_137514-00017"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_137514-00018"
    }
  }, [_vm._v("Gordon went into the street too full of horror and doubt to think clearly.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00099"
    }
  }, [_vm._v("“To be compared with a "), _c('i', [_vm._v("dog")]), _vm._v("! To be measured against a "), _c('i', [_vm._v("dog")]), _vm._v("! Oh no, God, Nan wouldn’t do that! Nan isn’t so wicked!”\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00100"
    }
  }, [_vm._v("He found he was gibbering these words and running as fast as possible home. He stopped, looked at his watch, forced himself to walk slowly. He arrived home about midnight, went through the close to the back court and looked up at the bedroom window. The light was out. He tiptoed upstairs and paused at the front door. The door looked so much as usual that he felt nothing wrong could be behind it; he could still return to the hotel, but while he considered this his hand was stealthily putting the key in the lock. He went softly into the living room, hesitated outside the bedroom door, then opened it quickly. He heard a gasp and Nan shriek, “Gordon!”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00101"
    }
  }, [_vm._v("“Yes,” said Gordon.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00102"
    }
  }, [_vm._v("“Don’t put the light on!”")])]), _c('p', {
    attrs: {
      "id": "rw-p_137514-00103"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_34"
    }
  }, [_vm._v("He switched the light on. Nan sat up in bed blinking at him fearfully, her hands pressed protectively on a mound between her legs under the tumbled bedclothes. Gordon stepped forward, gripped the edge of the bedclothes and tugged. “Let go!” he said. She stared at him, her face white with terror, and whispered, “Go away!” He struck her face and she fell back on the pillows; he snatched away the ")]), _c('a', {
    attrs: {
      "id": "pb-rw_35"
    }
  }, [_vm._v("bedclothes and the white dog sprang from between the sheets and danced on them, grinning. Gordon grabbed at the beast’s throat. With an easy squirming movement it evaded his hand, then bit it. Gordon felt the small needle-teeth sink between his fingerbones and suddenly became icy cold. He sat on the edge of the bed and stared at the numb bitten hand still gripped between the dog’s grinning jaws: its pink little eyes seemed to wink at him. With a great yell, he seized the beast’s hind leg with his free hand, sprang up and swung its whole body against the wall. Nan screamed. He felt its head crush with the impact, swung and battered it twice more on the wall, leaving a jammy red stain each time, then he flung the body into a corner and sat down on the edge of the bed and stared at his bitten hand. The sharp little teeth seemed to have gone in without piercing any veins or arteries, for the only mark on the skin was a V-shaped line of grey punctures. He stared across at the smash-headed carcase. He found it hard to believe he had killed it. "), _c('i', [_vm._v("Could")]), _vm._v(" such a creature be killed? He got to his feet with difficulty, for he felt unwell, and went to the thing. It was certainly dead. He opened the window, picked the dog up by the tail and flung it down into the back court, then went over to the bed where Nan lay, gazing at him with horror. He began to undress as well as he could without the use of the numbed right hand. “So, my dear,” he muttered, “you prefer convention.”\n         ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_35"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_137514-00104"
    }
  }, [_vm._v("She cried out, “You shouldn’t have come back tonight! We would all have been happy if you hadn’t come back tonight!”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00105"
    }
  }, [_vm._v("“Just so,” said Gordon, getting in bed with her.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00106"
    }
  }, [_vm._v("“Don’t touch me!”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_137514-00107"
    }
  }, [_vm._v("“Oh yes, I’ll touch you.”")])]), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_137514-00019"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_35"
    }
  }), _c('a', {
    attrs: {
      "id": "pb-rw_36"
    }
  }, [_vm._v("Toward morning Gordon woke, feeling wonderfully happy. Nan’s arms clasped him, yet he felt more free than ever before. With a little gleeful yelp he sprang from the nest of warmth made by her body and skipped upon the quilt. Nan opened her eyes lazily to him, then sat up and kissed his muzzle. He looked at her with jovial contempt, then jumped on to the floor and trotted out of the house, the shut doors springing open at the touch of his nose. He ran downstairs into the sunlit street, his mouth hanging open in a grin of sheer gaiety. He would never again be bound by dull laws.")])]), _c('a', {
    attrs: {
      "id": "pb-rw_36"
    }
  }, [_c('div', {
    staticClass: "media image align-center width-auto",
    attrs: {
      "id": "rw-media-image_137514-00004"
    }
  }, [_c('div', {
    staticClass: "pc"
  }, [_c('img', {
    attrs: {
      "alt": "alt",
      "src": "36-1.png"
    }
  })])])])]), _c('a', {
    attrs: {
      "id": "pb-rw_36"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_36"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e90d9f0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781847675026_chapter_05.vue
// module id = 93
// module chunks = 0